import type { RiskOversightResultByIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetRiskOversightResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskOversightResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRiskOversightResultByIdArgs = { id: string };

export const useGetRiskOversightResultById = createQueryHook<
  UseGetRiskOversightResultByIdArgs,
  RiskOversightResultByIdResponse,
  GetRiskOversightResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.assessment.riskOversightResultById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({
    risk_controlled_oversight_result: data.controlled,
    risk_uncontrolled_oversight_result: data.uncontrolled,
  }),
  graphqlDocument: GetRiskOversightResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
